export async function login(data) {
    return window.axios.post('/login', data);
}